import FAQ from './FAQ';
import css from './index.module.scss';
import { loginUser } from '@/utils/cookie';
import { useLang } from '@/i18n';
import { signupCookie } from '@/utils/cookies/signupCookie';

const B = () => {
    const { t } = useLang('recall.B');

    const handleGoForm = () => {
        const user = loginUser()?.user;
        if (user) {
            // 跳转表单
            window.open('efdelta-recall-reception', '_blank');
        } else {
            // 跳转登录
            signupCookie?.({ sector_name: t('module1Title'), entry_position: 2 });
            window.location.href = `login?redirect=${encodeURIComponent(window.location.href)}`;
        }
    };

    const handleGoLigin = () => {
        signupCookie?.({ sector_name: t('module1Title'), entry_position: 2 });
    };

    return (
        <div className={`${css.page}`}>
            <div className="B-module">
                <div className="B-module-title">{t('module1Title')}</div>
                <div>
                    <div className="B-sub-module">
                        <div>{t('module1Text1')}</div>
                        <div className="B-module-desc">{t('module1Text2')}</div>
                        <div className="B-module-img1">
                            <img src="https://websiteoss.ecoflow.com/upload/image/1735788404855/recall-1.jpeg" alt="" />
                            <span className="fw-700">{t('module1ImgName')}</span>
                        </div>
                        <div>
                            {t.rich('module1Text3', {
                                b: (v: string) => <span className="fw-700">{v}</span>,
                            })}
                        </div>
                        <div className="B-module-desc">{t('module1Text4')}</div>
                        <img className="B-module-img2" src="https://websiteoss.ecoflow.com/upload/image/1735876894329/recall-2.jpg" alt="" />
                    </div>
                </div>
            </div>
            <div className="B-module">
                <div className="B-module-title">{t('module2Title')}</div>
                <div>{t('module2Text1')}</div>
                <div className="B-module-img3">
                    <img src="https://websiteoss.ecoflow.com/upload/image/1735788404519/recall-3.png" alt="" />
                    <span className="fw-700">{t('module2ImgName')}</span>
                </div>
            </div>
            <div className="B-module">
                <div className="B-module-title">
                    {t.rich('module3Title', {
                        r: (v: string) => <span style={{ color: 'red' }}>{v}</span>,
                    })}
                </div>
                <div>{t('module3Text')}</div>
                <div className="fw-700">お手続きの流れ</div>
                <ul className="B-sub-module">
                    <li className="item">
                        本プログラムにお申込みいただくためには、EcoFlow会員登録していただく必要がございます。EcoFlowアカウントをお持ちでない場合は、
                        <a className="recall-link" onClick={handleGoLigin} href="login?redirect=%2Fjp%2Fmy-overview" target="_blank" rel="noreferrer">
                            こちらで新規作成できます
                        </a>
                        。
                    </li>
                    <li className="item">
                        下記「回収・交換受付フォーム」ボックスよりシリアルナンバーをご入力いただき、回収・交換の対象となるかご確認ください。※未登録の場合は、ログイン画面が表示されます。
                        <br></br>
                        <p>
                            シリアルナンバーが判別しづらい場合は、以下に挙げる資料のいずれか、または複数をご提出ください（状況により、複数の資料を同時にご依頼する場合がございます）：
                            <br></br>
                            <br></br>
                            <ul>
                                <li>● 注文番号、レシート、領収書などの購入を証明する書類 </li>
                                <li>● バーコードやラベルが鮮明に写った製品外装パッケージの写真</li>
                                <li>● EcoFlowアカウントに登録されている該当製品の保証登録履歴 </li>
                                <li>● 「自主回収」と手書きで記載し、撮影日とお申込者ご本人のお名前が写った製品本体の写真</li>
                                <li>● 販売店または修理業者発行の購入・流通証明書（大量申請の場合に限る）</li>
                                <li>
                                    万が一、製品が回収対象であることを確認できない場合でも、弊社において状況に応じた適切な対応策をご案内いたしますので、あらかじめご了承ください。
                                </li>
                            </ul>
                            <br></br>
                        </p>
                    </li>
                    <li className="item">
                        フォームに必要情報をご記入いただき、送信してください。お手続き完了後、交換製品「DELTA
                        2」を発送いたします。※到着まで7～14日程度の日数を頂いております。
                    </li>
                    <li className="item">
                        「DELTA 2」がお届けになりましたら、「DELTA
                        2」の梱包箱と耐火シートをお使い頂き、バッテリー残量を0％まで放電した「EFDELTA」を梱包してください。後日配送業者が「EFDELTA」の集荷に伺います。「EFDELTA」に同梱されているXT60変換ソーラー充電ケーブル（MC4からXT60へ入力
                        ）のご返送は必要がございません。
                    </li>
                    <li className="item">ご返送いただいた「EFDELTA」の到着を確認後、「DELTA 2」の5年間の保証期間が開始されます。</li>
                </ul>
            </div>
            <div className="B-module">
                <div className="B-module-title">{t('module4Title')}</div>
                <div>
                    {t.rich('module4Text', {
                        l: (v: string) => (
                            <a className="recall-link" href="efdelta-discharge-information" target="_blank" rel="noreferrer">
                                {v}
                            </a>
                        ),
                    })}
                </div>
                <ul className="B-sub-module">
                    <li className="item">{t('module4li1')}</li>
                    <li className="item">{t('module4li2')}</li>
                    <li className="item">{t('module4li3')}</li>
                    <li className="item">{t('module4li4')}</li>
                    <li className="item">{t('module4li5')}</li>
                </ul>
            </div>
            <div className="B-module">
                <div className="B-module-title">{t('module5Title')}</div>
                <ul className="B-sub-module module-faq">
                    <FAQ />
                    <li className="item2">
                        {t.rich('module5li1', {
                            l: (v: string) => (
                                <a className="recall-link" href="mailto:efdelta.support@ecoflow.com">
                                    {v}
                                </a>
                            ),
                        })}
                    </li>
                    <li className="item2">
                        {t.rich('module5li2', {
                            l: (v: string) => (
                                <a className="recall-link" href="tel:050‐3355‐3196">
                                    {v}
                                </a>
                            ),
                        })}
                    </li>
                </ul>
                <button className="B-module-button" onClick={handleGoForm}>
                    {t('module5Button')}
                </button>
            </div>
        </div>
    );
};
export default B;
